import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Icons } from "./ChecklistIcons";
import { ChecklistItem } from "./ChecklistItem";
import type { ChecklistData, ChecklistFase } from "./types";
interface ChecklistCardProps {
  data: ChecklistData;
  checkedItems: Record<string, string[]>;
  onToggleItem: (listId: string, itemIndex: string) => void;
  onPrint: () => void;
}
const FaseSection = t0 => {
  const $ = _c(21);
  const {
    fase,
    fIndex,
    listId,
    checkedItems,
    onToggleItem
  } = t0;
  let t1;
  if ($[0] !== fase.title) {
    t1 = <h3 className="text-sm md:text-base font-black text-brand-600 dark:text-brand-400 uppercase tracking-wide mb-3 flex items-center gap-2">{fase.title}</h3>;
    $[0] = fase.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== fase.description) {
    t2 = fase.description && <p className="description-text text-[10px] text-slate-500 mb-3 italic">{fase.description}</p>;
    $[2] = fase.description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== checkedItems || $[5] !== fIndex || $[6] !== fase.items || $[7] !== listId || $[8] !== onToggleItem) {
    let t4;
    if ($[10] !== checkedItems || $[11] !== fIndex || $[12] !== listId || $[13] !== onToggleItem) {
      t4 = (item, iIndex) => {
        const globalIndex = `${fIndex}-${iIndex}`;
        return <ChecklistItem key={iIndex} item={item} isChecked={(checkedItems || []).includes(globalIndex)} onToggle={() => onToggleItem(listId, globalIndex)} />;
      };
      $[10] = checkedItems;
      $[11] = fIndex;
      $[12] = listId;
      $[13] = onToggleItem;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = fase.items.map(t4);
    $[4] = checkedItems;
    $[5] = fIndex;
    $[6] = fase.items;
    $[7] = listId;
    $[8] = onToggleItem;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[15] !== t3) {
    t4 = <div className="fase-items-grid grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">{t3}</div>;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t4) {
    t5 = <section className="section-gap">{t1}{t2}{t4}</section>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
const VerdictSection = t0 => {
  const $ = _c(13);
  const {
    data
  } = t0;
  if (!data.verdict) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h4 className="text-brand-600 dark:text-brand-500 font-black uppercase text-[10px] md:text-xs mb-3">📉 Negocjuj cenę:</h4>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== data.verdict.negotiate) {
    t2 = data.verdict.negotiate.map(_temp);
    $[1] = data.verdict.negotiate;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="bg-slate-50 dark:bg-slate-950/50 p-4 md:p-6 rounded-xl border border-slate-200 dark:border-slate-800">{t1}<ul className="space-y-1">{t2}</ul></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h4 className="text-red-600 dark:text-red-500 font-black uppercase text-[10px] md:text-xs mb-3">🛑 NIE KUPUJ:</h4>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== data.verdict.stop) {
    t5 = data.verdict.stop.map(_temp2);
    $[6] = data.verdict.stop;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="bg-red-50 dark:bg-red-950/10 p-4 md:p-6 rounded-xl border border-red-200 dark:border-red-900/30">{t4}<ul className="space-y-1">{t5}</ul></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className="verdict-container grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 pt-6 md:pt-8 border-t border-slate-200 dark:border-slate-800 mt-6 md:mt-10">{t3}{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export const ChecklistCard = t0 => {
  const $ = _c(42);
  const {
    data,
    checkedItems,
    onToggleItem,
    onPrint
  } = t0;
  let t1;
  if ($[0] !== data.title) {
    t1 = <h2 className="text-lg md:text-2xl font-black text-slate-900 dark:text-white uppercase">{data.title}</h2>;
    $[0] = data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.type) {
    t2 = <div className="flex items-center gap-3 mt-1"><span className="text-[9px] bg-brand-100 dark:bg-brand-900/50 text-brand-700 dark:text-brand-400 border border-brand-200 dark:border-brand-500/30 px-2 py-0.5 rounded font-black uppercase tracking-widest">{data.type}</span></div>;
    $[2] = data.type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icons.Download className="w-3.5 h-3.5" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onPrint) {
    t5 = <button onClick={onPrint} className="no-print flex items-center gap-1.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-900 dark:text-white px-4 py-2 rounded-lg text-xs font-bold border border-slate-200 dark:border-slate-700 transition-colors">{t4}Drukuj</button>;
    $[8] = onPrint;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="p-5 md:p-8 border-b border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-850/50 flex justify-between items-center gap-4">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="no-print">Przy każdym elemencie znajduje się ikona info - po najechaniu na nią znajdziesz szczegółowy opis danego punktu.</p>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== checkedItems || $[15] !== data.fases || $[16] !== data.id || $[17] !== onToggleItem) {
    let t9;
    if ($[19] !== checkedItems || $[20] !== data.id || $[21] !== onToggleItem) {
      t9 = (fase, fIndex) => <FaseSection key={fIndex} fase={fase} fIndex={fIndex} listId={data.id} checkedItems={checkedItems[data.id]} onToggleItem={onToggleItem} />;
      $[19] = checkedItems;
      $[20] = data.id;
      $[21] = onToggleItem;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    t8 = data.fases.map(t9);
    $[14] = checkedItems;
    $[15] = data.fases;
    $[16] = data.id;
    $[17] = onToggleItem;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[23] !== t8) {
    t9 = <div className="space-y-6 md:space-y-10">{t7}{t8}</div>;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== data) {
    t10 = <VerdictSection data={data} />;
    $[25] = data;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Icons.FileText className="w-10 h-10 text-gold-500 shrink-0" />;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="no-print bg-gradient-to-br from-slate-100 to-slate-200 dark:from-slate-800 dark:to-slate-900 p-6 md:p-8 rounded-2xl border border-slate-200 dark:border-slate-700 mt-8 flex flex-col md:flex-row items-center gap-6 text-center md:text-left">{t11}<div className="flex-grow"><h4 className="text-base font-black text-slate-900 dark:text-white uppercase mb-1">Bonus: Wzór Umowy</h4><p className="text-slate-600 dark:text-slate-400 text-xs mb-4">Pobierz gotowy, bezpieczny wzór umowy kupna-sprzedaży broni.</p><a href="/files/UMOWA-KUPNA-SPRZEDAZY-BRONI-PALNEJ-SPRAWDZONA-BRON.pdf" target="_blank" className="px-5 py-2 bg-gold-500 hover:bg-gold-400 text-slate-950 font-black text-[10px] uppercase rounded-lg transition-all shadow-lg shadow-gold-500/20">Pobierz Wzór</a></div></div>;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== data.footer) {
    t13 = <p className="text-slate-500 text-[10px] md:text-xs font-medium italic">"{data.footer}"</p>;
    $[29] = data.footer;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mt-4 flex justify-center no-print"><Link href="/" className="text-brand-600 dark:text-brand-500 font-black uppercase text-[9px] hover:underline flex items-center gap-2">← Powrót do SprawdzonaBron.pl</Link></div>;
    t15 = <div className="hidden print-only text-center mt-2 font-bold text-slate-400">Wygenerowano na SprawdzonaBron.pl - Największa porównywarka cen broni w Polsce.</div>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t14 = $[31];
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13) {
    t16 = <footer className="marketing-footer text-center pt-6 md:pt-8 border-t border-slate-200 dark:border-slate-800 mt-6 md:mt-10">{t13}{t14}{t15}</footer>;
    $[33] = t13;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t10 || $[36] !== t16 || $[37] !== t9) {
    t17 = <div className="card-padding p-5 md:p-8">{t9}{t10}{t12}{t16}</div>;
    $[35] = t10;
    $[36] = t16;
    $[37] = t9;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t17 || $[40] !== t6) {
    t18 = <div className="checklist-card bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl md:rounded-3xl shadow-2xl animate-fade-in">{t6}{t17}</div>;
    $[39] = t17;
    $[40] = t6;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
function _temp(v, i) {
  return <li key={i} className="text-[10px] md:text-xs text-slate-600 dark:text-slate-400 flex items-center gap-1.5"><span className="text-brand-500">•</span> {v}</li>;
}
function _temp2(v_0, i_0) {
  return <li key={i_0} className="text-[10px] md:text-xs text-slate-600 dark:text-slate-400 flex items-center gap-1.5"><span className="text-red-500">❌</span> {v_0}</li>;
}